import BackstageComment from './BackstageComment.interface';
import { UserData } from './UserData.interface';

export interface IOtrForm {
  title: string;
  description: string;
  src_url?: any;
  username?: string;
  categories?: OtrType[];
}

export interface OtrData {
  id: number;
  title: string;
  description: string;
  src_url?: any;
  username?: string;
  owner_id: number;
  comments: BackstageComment[];
  isVertical: boolean;
  views: number;
  likes: number[];
  user: UserData;
  categories: OtrType[];
  createdAt: Date;
}

export interface IOtrState {
  otrs?: OtrData[];
  userOtrs?: OtrData[];
  loading: boolean;
  otrIndex: number;
  preferredCategories?: OtrType[];
}

export enum OtrType {
  trading = 0,
  utility = 1,
  virtual = 2,
  art = 3,
  collectibles = 4,
  domains = 5,
  music = 6,
  photography = 7,
  sports = 8,
}
